export default __webpack_public_path__ + "static/AdobeInDesign-43caa9940234265b915b63dc0dcf1a18.pdf";